import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { getMessageGroups } from "../actions/messageGroups.actions";
import { messageGroupsQueryKeys } from "../messageGroups.queryKeys";
import { MessageGroupSummary } from "../messageGroups.types";

export const useMessageGroupsListQuery = ({ companyId = undefined as number | string | null | undefined, enabled = true } = {}) => {
  const token = sessionStorage.getItem("token");
  const activeCompanyId = useSelector((state: any) => state.userState.activeCompanyId);
  const effectiveCompanyId = companyId ?? activeCompanyId;

  const query = useQuery({
    queryKey: messageGroupsQueryKeys.list(effectiveCompanyId),
    queryFn: () => getMessageGroups(token, { pageSize: 100, companyId: effectiveCompanyId }),
    enabled: Boolean(token && effectiveCompanyId) && enabled,
    refetchOnWindowFocus: false,
  });

  const groups: MessageGroupSummary[] = query.data?.items ?? [];
  const totalUnread = groups.reduce((total, group) => total + (group.unreadCount || 0), 0);

  return { ...query, groups, totalUnread, activeCompanyId: effectiveCompanyId };
};
